<template>
  <el-dialog :title="$t('detailsText')" :visible.sync="dialogTableVisible" append-to-body>
    <b>{{ $t('goodsSku.detail.qty') }} : {{ gridData[0] && gridData[0].qty || 0 }}</b>
    <br />
    <br />
    <el-table border script :data="gridData">
      <el-table-column align="center" prop="length" :label="$t('goodsSku.detail.length')"></el-table-column>
      <el-table-column align="center" prop="width" :label="$t('goodsSku.detail.width')"></el-table-column>
      <el-table-column align="center" prop="height" :label="$t('goodsSku.detail.height')"></el-table-column>
      <el-table-column align="center" prop="weight" :label="$t('goodsSku.detail.weight')"></el-table-column>
      <el-table-column align="center" :label="$t('goodsSku.detail.UnitVolume')">
        <template slot-scope="scope">
          <span>{{ (scope.row.width*scope.row.height*scope.row.length/1000000) }}m³</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="qty" :label="$t('goodsSku.detail.itemPerCarton')"></el-table-column>
    </el-table>
    <el-table border script :data="gridData" style="margin-bottom:20px">
      <el-table-column align="center" prop="cartonLength" :label="$t('goodsSku.detail.cartonLength')"></el-table-column>
      <el-table-column align="center" prop="cartonWidth" :label="$t('goodsSku.detail.cartonWidth')"></el-table-column>
      <el-table-column align="center" prop="cartonHeight" :label="$t('goodsSku.detail.cartonHeight')"></el-table-column>
      <el-table-column align="center" prop="cartonWeight" :label="$t('goodsSku.detail.cartonWeight')"></el-table-column>
      <el-table-column align="center" :label="$t('goodsSku.detail.cartonVolume')">
        <template slot-scope="scope">
          <span>{{ (scope.row.cartonWidth*scope.row.cartonHeight*scope.row.cartonLength/1000000) }}m³</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="usableNum" :label="$t('goodsSku.detail.stockQty')"></el-table-column>
    </el-table>
  </el-dialog>
</template>
<script>
import { goodsApi } from '@/api';
export default {
  props: {
    orderId: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      dialogTableVisible: false,
      gridData: [],
    };
  },
  methods: {
    show(r) {
      this.dialogTableVisible = true;
      // 根据skuCode获取所需id
      goodsApi.getSku2([r.skuCode]).then(res => {
        this.gridData = res;
      });
    }
  },
};
</script>
